import { render } from "./knowledgeListView.vue?vue&type=template&id=1fd4d23c&scoped=true&ts=true"
import script from "./knowledgeListView.vue?vue&type=script&lang=ts"
export * from "./knowledgeListView.vue?vue&type=script&lang=ts"

import "./knowledgeListView.vue?vue&type=style&index=0&id=1fd4d23c&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fd4d23c"]])

export default __exports__